import {SiePedidosBaseAPI} from "@/api/sie-pedidos.base.api";
import {
  VUE_APP_SIE_PEDIDOS_API_URL
} from "@/commons/config";
import {AxiosObservable} from "axios-observable/dist/axios-observable.interface";
import {DadosAluno} from "@/models/sie-pedidos/dadosAluno";
import {Pagination} from "@/models/sit-pedido/pagination";
import {Lote} from "@/models/sie-pedidos/lote";
import {DadosFilterLotes, PaginationTableLotes} from "@/store/modules/sie-pedidos/states/tableLotes";
import dayjs from "dayjs";

export class GraficaApi extends SiePedidosBaseAPI<DadosAluno> {

  constructor() {
    super();
    this.apiUrl = VUE_APP_SIE_PEDIDOS_API_URL;
  }

public getListaLotes(input: PaginationTableLotes): AxiosObservable<Pagination<Lote>> {
  const url = `${this.apiUrl}/central-servicos/lotes/consulta-lote-grafica`;

  const normalizeDate = (value?: string | null): string | undefined => {
    if (!value) return undefined;
    const d = dayjs(value);
    return d.isValid() ? d.format("YYYY-MM-DD") : undefined;
  };

  const dataInicio = normalizeDate(input.dataInicio);
  const dataFim = normalizeDate(input.dataFim) ?? dataInicio;

  const params: Record<string, any> = { ...input };

  if (dataInicio) {
    params.dataInicio = dataInicio;
  } else {
    delete params.dataInicio;
  }

  if (dataFim) {
    params.dataFim = dataFim;
  } else {
    delete params.dataFim;
  }

  return this.axios.get(url, { params });
}

  public getDadosFilterGrafica(): AxiosObservable<DadosFilterLotes> {
    return this.axios.get(`${this.apiUrl}/central-servicos/graficas/lotes/setup-list`);
  }
  public downloadLote (id: number): AxiosObservable<Blob> {
    return this.axios.post(`${this.apiUrl}/central-servicos/lotes/${id}/download-grafica`, '', { responseType: 'blob' }  )
  }
  public enviarLoteSindionibus(id: number): AxiosObservable<any>{
    return this.axios.put(`${this.apiUrl}/central-servicos/lotes/grafica-enviar-lote/${id}`,);
  }
}
